import React from 'react';
import ReactDOM from 'react-dom';
import 'lib-flexible'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ReactGA from "react-ga";
import { GAID, GOOGLE_ANALYTICS } from './commons/Constants';

if (GOOGLE_ANALYTICS){
  ReactGA.initialize(GAID);
  ReactGA.pageview(window.location.pathname + window.location.search);
} 

ReactDOM.render(
  // <React.StrictMode>
    <App />  ,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
